// extracted by mini-css-extract-plugin
module.exports = {"image":"thumbnail_image__2JMsh"};